import makeStyles from '@mui/styles/makeStyles';

const useFileuploadStyles = makeStyles({
  root: {}
});

export default useFileuploadStyles;
